export default "__VITE_ASSET__DWGL_02Y__"